var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"editor",staticStyle:{"text-align":"left"}})
}
var staticRenderFns = []

export { render, staticRenderFns }